<template>
    <div>
        <div style="border: 1px solid #ccc">
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
            />
            <Editor
                style="height: 500px; overflow-y: hidden"
                v-model="html"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
            />
        </div>
        <!-- <br />
        <el-button @click="getEditorHtml">get html</el-button>
        <el-button @click="setEditorHtml">set html</el-button> -->
    </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css";
import { Storage } from "../../../utils/storage";

export default {
    name: "rich-text",
    components: { Editor, Toolbar },
    data() {
        return {
            editor: null,
            mode: "default",
            html: "",
            toolbarConfig: {
                toolbarKeys: [
                    "bold",
                    "underline",
                    "italic",
                    "through",
                    "color",
                    "bgColor",
                    "fontSize",
                    "fontFamily",
                    "indent",
                    "delIndent",
                    "justifyLeft",
                    "justifyRight",
                    "justifyCenter",
                    "justifyJustify",
                    "lineHeight",
                    "insertImage",
                    "deleteImage",
                    "imageWidth30",
                    "imageWidth50",
                    "imageWidth100",
                    "headerSelect",
                    "header1",
                    "header2",
                    "header3",
                    "header4",
                    "header5",
                    "todo",
                    "redo",
                    "undo",
                    "enter",
                    "bulletedList",
                    "numberedList",
                    "uploadImage",
                    "emotion",
                    "divider",
                    "insertLink",
                    "editLink",
                    "unLink",
                    "viewLink",
                    "blockquote",
                ],
                excludeKeys: [
                    "fullScreen",
                    "insertImage",
                    "insertTable",
                    "codeBlock",
                    "divider",
                    "insertVideo",
                    "uploadVideo",
                    "editVideoSize",
                    "codeSelectLang",
                ],
            },
            editorConfig: {
                placeholder: "请输入内容...",
                MENU_CONF: {
                    uploadImage: {
                        server: `${process.env.VUE_APP_V1}/v1/admin/blog/upload/image`,
                        headers: {
                            Authorization: Storage.getItem("token"),
                        },
                        fieldName: "picture",
                        customInsert(res, insertFn) {
                            // url alt href
                            console.log("img----->", res);
                            const url = `https://asset.promptport.ai/files${res.data.url}`;
                            insertFn(url);
                        },
                    },
                },
            },
        };
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor);
        },
        getEditorHtml() {
            const editor = this.editor;
            if (editor == null) return;
            console.log("btn---->", editor.getHtml());
        },
        setEditorHtml() {
            const editor = this.editor;
            if (editor == null) return;
            editor.setHtml("");
        },
    },
    beforeDestroy() {
        const editor = this.editor;
        if (editor == null) return;
        editor.destroy();
    },
};
</script>

<style>
</style>